import config from "./config";
// import api from './api'
import tool from "./utils/tool";
// import errorHandler from './utils/errorHandler'
// import * as elIcons from '@element-plus/icons-vue'
export default {
	install(app) {
		//挂载全局对象
		app.config.globalProperties.$CONFIG = config;
		app.config.globalProperties.$TOOL = tool;

		//注册全局组件
		//注册全局指令
		//统一注册el-icon图标
		//全局代码错误捕捉
		// app.config.errorHandler = errorHandler
	},
};
